'use client';

import { supabase } from '@/lib/supabase/client';

export async function obtenerUser(userId: string) {
  const { data, error } = await supabase
    .schema('app_utils')
    .from('users')
    .select('*')
    .eq('id', userId)
    .single();

  if (error) throw error;
  return data;
}
